import {PreOrderRetrieveResponse} from '@yandex-delivery/api/repo/dcaa'

import {Order, RequirementsMap} from 'src/shared/types'

export const toOfferFlow = (preOrderRetrieve: PreOrderRetrieveResponse): Order['offerFlow'] => {
  const requirements: RequirementsMap = {
    insurance: {
      name: 'insurance',
      title: 'Страховка',
      text: 'Покроет убытки до 500 000 ₽, если с посылкой что-то случится',
      trail_title: 'Вкл.',
      type: 'included',
      selectedValue: true,
    },
  }

  const offerRequirements = preOrderRetrieve.claim.offer_requirements

  if (offerRequirements?.cargo_type) {
    requirements.cargo_type = {
      name: 'cargo_type',
      title: 'Тип кузова',
      text: 'Тип кузова',
      type: 'select',
      required: false,
      options: [],
      selectedValue: offerRequirements.cargo_type,
    }
  }

  if (offerRequirements?.cargo_loaders) {
    requirements.cargo_loaders = {
      name: 'cargo_loaders',
      title: 'Грузчики',
      text: 'Грузчики',
      type: 'select',
      required: false,
      options: [],
      selectedValue: offerRequirements.cargo_loaders,
    }
  }

  if (offerRequirements?.skip_door_to_door) {
    requirements.door_to_door = {
      name: 'door_to_door',
      title: 'От двери до двери',
      text: 'От двери до двери',
      type: 'bool',
      default_value: false,
      required: false,
      selectedValue: Boolean(preOrderRetrieve.claim.offer_requirements?.skip_door_to_door),
    }
  }

  const offerFlow: Order['offerFlow'] = {
    vertical: {
      name: 'cargo',
      requirements,
    },
  }

  if (offerRequirements?.due) {
    offerFlow.deliveryType = 'toTime'

    const due = new Date(offerRequirements.due)
    const date = String(due.getDate()).padStart(2, '0')
    const month = String(due.getMonth() + 1).padStart(2, '0')
    const year = due.getFullYear()

    offerFlow.deliveryDate = `${date}.${month}.${year}`

    offerFlow.deliveryInterval = {
      from: offerRequirements.due,
      to: offerRequirements.due,
    }
  }

  return offerFlow
}
